<mat-toolbar class="header-content">
    <div class="header-title">
        <mat-icon>{{ mode === 'edit' ? 'edit' : 'visibility' }}</mat-icon>
        <span class="header-name">{{ isNew ? ('menu.devices.configs.new_template' | translate) : config?.name }}</span>
        <span class="queue-position" *ngIf="isSequential">({{ queuePosition }}/{{ queueTotal }})</span>
    </div>

    <lib-button icon="close" color="none" textColor="muted" (click)="close()"
        tooltip="{{'viewer.close'|translate}}"></lib-button>
</mat-toolbar>

<mat-dialog-content>
    <ng-container *ngIf="mode === 'view'">
        <div class="detail-row">
            <span class="detail-label">{{'datatable.type'|translate}}</span>
            <span class="type-chip">{{ config?.type }}</span>
        </div>

        <div class="detail-row" *ngIf="config?.offlineDelay">
            <span class="detail-label">{{'units.device.offline_delai'|translate}}</span>
            <span>{{ config?.offlineDelay }}s</span>
        </div>

        <div class="settings-section" *ngIf="settingsEntries.length">
            <h4>{{'resources.tracker_config'|translate}}</h4>

            <table class="settings-table">
                <tr *ngFor="let entry of settingsEntries">
                    <td class="settings-key">{{ entry.key }}</td>
                    <td class="settings-value">{{ entry.value }}</td>
                </tr>
            </table>
        </div>

        <div class="trackers-section">
            <h4>{{'menu.devices.configs.used_by'|translate}}</h4>

            <p *ngIf="!trackers.length" class="no-trackers">{{'menu.devices.configs.used_by_none'|translate}}</p>

            <div class="tracker-chips" *ngIf="trackers.length">
                <span class="tracker-chip" *ngFor="let tracker of trackers">{{ tracker.name }}</span>
            </div>
        </div>

        <div class="button-group">
            <lib-button color="none" textColor="danger" icon="delete" (click)="delete()"
                text="{{'form.delete'|translate}}"></lib-button>

            <lib-button color="primary" icon="edit" (click)="startEdit()"
                text="{{'form.edit'|translate}}"></lib-button>
        </div>
    </ng-container>

    <app-tracker-config-form *ngIf="mode === 'edit'" [config]="configDraft" [existingConfigs]="configs" (save)="save()"
        (cancelForm)="cancelEdit()"></app-tracker-config-form>
</mat-dialog-content>
